/**
 * om-media-group.js
 *
 * Companion to the colour groups in snippets/product.liquid (om_media_groups).
 *
 * The gallery renders every product image and the OmMediaGroup-<section> style
 * hides the groups of the other colours, so the first paint already shows the
 * selected colour. product-info.js re-fetches the whole section on every option
 * change but does not touch that style, so this subscriber copies the fetched
 * rule after the variantChange event. The Easy Variant Images app may rebuild
 * the slides as well; its clones keep data-om-media-group, so the rule applies
 * to them too.
 */
(function () {
  'use strict';

  if (window.__omMediaGroupInit) return;
  window.__omMediaGroupInit = true;

  function init() {
    if (typeof subscribe !== 'function' || !window.theme || !window.theme.PUB_SUB_EVENTS) return;

    subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.html || !data.sectionId) return;

      var fetched = data.html.getElementById('OmMediaGroup-' + data.sectionId);
      var live = document.getElementById('OmMediaGroup-' + data.sectionId);
      if (!fetched || !live) return;

      live.textContent = fetched.textContent;
    });
  }

  // Deferred, so the DOM is parsed and theme.dev.js (subscribe) has already run: start now rather than on
  // DOMContentLoaded, which Cookiebot auto-blocking holds back for seconds.
  if (document.readyState === 'loading' || typeof subscribe !== 'function') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
